import { createAction, createSlice } from "@reduxjs/toolkit";

const getProfileSlice = createSlice({
  name: "getProfile",
  initialState: { data: [], success: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const profile = action.payload.data;
      state.data = profile;
      state.success = true;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    update(state, action) {
      const { data } = action.payload;
      state.data = data;
    },
  },
});

const { name, actions, reducer } = getProfileSlice;
const getProfileAction = createAction(name);

export {
  getProfileAction,
  actions as getProfileActions,
  reducer as getProfileReducer,
};
